import Add from '@mui/icons-material/Add'
import FileDownload from '@mui/icons-material/GetApp'
import SendEmail from '@mui/icons-material/Send'
import { IconButton } from '@mui/material'
import { IInvoice } from 'models/invoices.models'
import {
  getInvoiceFormattedCurrency,
  getInvoiceFormattedDate,
} from 'lib/utils/Invoices/invoices.utils'
import {
  ICFDIsContainerProps,
  useCFDIsContainerContext,
} from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import Button from 'components/Shared/Button/Button'
import Table from 'components/Shared/DynamicTable/DynamicTable'
import SydDialog from 'components/Shared/SydDialog/SydDialog'
import './styles.scss'

// TODO: UPDATE HEADERS AND TABLE WITH SydTable, CreditNoteTableActions & PaymentComplementTableActions COMPONENTS.

type TCFDIRelatedDocsProps = Pick<ICFDIsContainerProps, 'onRedirect'>

const CFDIRelatedDocs = ({ onRedirect }: TCFDIRelatedDocsProps) => {
  const {
    activeInvoice,
    creditNoteListQuery,
    downloadCreditNoteQuery,
    downloadPayComplementQuery,
    payComplementListQuery,
    relatedDocsDialogOpen,
    selectedAddonVersion,
    sendCreditNoteByEmailMutation,
    sendPayComplementByEmailMutation,
    updateState,
  } = useCFDIsContainerContext()

  const typedInvoice = activeInvoice as IInvoice

  const necessaryId = typedInvoice?.idCfdi

  const formatActionsCreditNote = (id: number, row: any, key: any) => (
    <>
      <IconButton
        id={`downloadCreditNoteBtn_${key}`}
        title="Descargar"
        size="small"
        color="primary"
        onClick={e => {
          e.stopPropagation()
          updateState(draft => {
            draft.selectedCreditNote = row
          })
          downloadCreditNoteQuery.refetch()
        }}>
        <FileDownload fontSize="inherit" />
      </IconButton>
      <IconButton
        id={`sendCreditNoteBtn_${key}`}
        title="Enviar por email"
        size="small"
        color="primary"
        onClick={e => {
          e.stopPropagation()
          typedInvoice &&
            sendCreditNoteByEmailMutation.mutate({
              creditNote: row,
              invoice: typedInvoice,
            })
        }}>
        <SendEmail fontSize="inherit" />
      </IconButton>
    </>
  )

  const formatActionsPayComplement = (id: number, row: any, key: any) => (
    <>
      <IconButton
        id={`downloadPayComplementBtn_${key}`}
        title="Descargar"
        size="small"
        color="primary"
        onClick={e => {
          e.stopPropagation()
          updateState(draft => {
            draft.selectedPayComplement = row
          })
          downloadPayComplementQuery.refetch()
        }}>
        <FileDownload fontSize="inherit" />
      </IconButton>
      <IconButton
        id={`sendPayComplementBtn_${key}`}
        title="Enviar por email"
        size="small"
        color="primary"
        onClick={e => {
          e.stopPropagation()
          typedInvoice &&
            sendPayComplementByEmailMutation.mutate({
              payComplement: row,
              invoice: typedInvoice,
            })
        }}>
        <SendEmail fontSize="inherit" />
      </IconButton>
    </>
  )

  const creditNoteHeaders = [
    {
      label: 'Fecha de Pago',
      accesor: 'createdAt',
      renderer: getInvoiceFormattedDate,
    },
    { label: 'UUID', accesor: 'uuid' },
    { label: 'Total', accesor: 'total', renderer: getInvoiceFormattedCurrency },
    {
      label: '',
      accesor: 'idCfdi',
      renderer: formatActionsCreditNote,
      cellClassName: 'options',
    },
  ]

  const paymentComplementHeaders = [
    {
      label: 'Fecha de Pago',
      accesor: 'paymentDate',
      renderer: getInvoiceFormattedDate,
    },
    { label: 'UUID', accesor: 'uuid' },
    {
      label: 'Total',
      accesor: 'amount',
      renderer: getInvoiceFormattedCurrency,
    },
    {
      label: '',
      accesor: 'idCfdi',
      renderer: formatActionsPayComplement,
      cellClassName: 'options',
    },
  ]

  return (
    <SydDialog
      open={relatedDocsDialogOpen}
      className="dialog-invoices cfdi-related-docs"
      onCancel={() =>
        updateState(draft => {
          draft.relatedDocsDialogOpen = false
        })
      }
      hidePrimaryButton
      secondaryButtonText="Cerrar"
      sideButtons
      fullWidth>
      <h1>Lista de Complementos de Pago</h1>
      <Button
        id="addPaymentComplementBtn"
        variant="contained"
        color="secondary"
        startIcon={<Add />}
        onClick={() =>
          !!necessaryId &&
          onRedirect('addPaymentComplement', necessaryId, selectedAddonVersion)
        }>
        Agregar complemento de pago
      </Button>
      <Table
        headers={paymentComplementHeaders}
        rows={payComplementListQuery.data ?? []}
        loading={payComplementListQuery.isLoading}
        fetching={payComplementListQuery.isFetching}
      />

      <h1>Lista de Notas de credito</h1>
      <Button
        id="addCreditNoteBtn"
        variant="contained"
        color="secondary"
        startIcon={<Add />}
        onClick={() =>
          !!necessaryId &&
          onRedirect('addCreditNote', necessaryId, selectedAddonVersion)
        }>
        Agregar nota de credito
      </Button>

      <Table
        headers={creditNoteHeaders}
        rows={creditNoteListQuery.data ?? []}
        loading={creditNoteListQuery.isLoading}
        fetching={creditNoteListQuery.isFetching}
      />
    </SydDialog>
  )
}

export default CFDIRelatedDocs
